// angular
// 	.module("HeroPRO")
// 	.controller("ProductAddedController", productAddedController);


import './productAdded.scss';

/* @ngInject */
export default function productAddedController(FRInformationFactory, FRClosingFactory, SelectedProductsFactory, ModalService, $analytics, HPStateMachineConfig, AddProductsFactory) {
    const vm = this;
    vm.appInfo = {};
    vm.products = {};
    vm.productSubtotal = 0;
    vm.financingTerm = 0;
    vm.interestAndFees = 0;
    vm.prePayment = 0;
    vm.projectTotal = 0;
    vm.productsLoaded = false;
    vm.addedProductCaseInfo = {};

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */
    vm.openAddProductsModal = function (visibleModules) {
        ModalService.launchLgModal({
            templateUrl: 'app/appDetail/addProducts/addProductsModal.html',
            windowClass: 'add-products-modal full-screen',
            controller: 'AddProductsModalController',
            controllerAs: 'addProductsModal',
            size: 'full-screen',
            animation: false,
            resolve: {
                visibleModules() {
                    return visibleModules || [];
                },
            },
        });

        if (visibleModules === undefined) {
            $analytics.eventTrack('Add More Products', { category: 'Walkthrough' });
        } else {
            $analytics.eventTrack('Set Term', { category: 'Walkthrough' });
        }
    };

    vm.openAddProductsWebsite = function () {
        AddProductsFactory.openAddProductsWebsite();
    };

    /* -----  End of Public Functions  ------*/


    /*= =======================================
	 =            Private Functions            =
	 ======================================== */

    function init() {
        FRInformationFactory.getFundingRequestInformationPromise().then(() => {
            vm.appInfo = FRInformationFactory.getAppInfo();

            SelectedProductsFactory.getAddedProducts({ FundingRequestId: vm.appInfo.FundingRequestId }, true).then(() => {
                vm.products = angular.copy(SelectedProductsFactory.getSelectedProducts());
                if (vm.products.length > 0) {
                    vm.productSubtotal = SelectedProductsFactory.getProductSubtotal();
                    vm.financingTerm = SelectedProductsFactory.getFinancingTerm();
                    SelectedProductsFactory.getInterestAndFees(vm.appInfo).then((response) => {
                        vm.interestAndFees = response;
                        if (vm.appInfo.ClosingPrepayCAPI !== undefined && vm.appInfo.ClosingPrepayCAPI === true) {
                            vm.prePayment += vm.interestAndFees.CAPI || vm.interestAndFees.CAPIPrepay;
                        }
                        if (vm.appInfo.ClosingPrepayFees !== undefined && vm.appInfo.ClosingPrepayFees === true) {
                            vm.prePayment += vm.interestAndFees.ClosingCosts || vm.interestAndFees.ClosingCostsPrepay;
                        }
                        vm.projectTotal = SelectedProductsFactory.getProjectTotal();// - vm.prePayment;
                        vm.productsLoaded = true;
                    });
                }
            });

            // If the application is in the Products_Submitted state, get the case information
            if (vm.appInfo.LoanStateId === HPStateMachineConfig.Loan.Products_Submitted) {
                AddProductsFactory.getAddedProductsCase(vm.appInfo.FundingRequestId).then((response) => {
                    vm.addedProductCaseInfo = response.data;
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/appDetail/walkthrough/application/productAddedController.js